import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Hashtag from 'brighteon/components/hashtag';
import ColumnHeader from '../../components/column_header';
import ScrollableList from '../../components/scrollable_list';
import Column from '../ui/components/column';
import { fetchTrends } from '../../actions/trends';

const messages = defineMessages({
  title: { id: 'trends.trending_now', defineMessage: 'Trending Now' },
});

const mapStateToProps = state => ({
  trends: state.getIn(['trends', 'items']),
});

export default @connect(mapStateToProps)
@injectIntl
class TrendingNowTimeline extends ImmutablePureComponent {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    shouldUpdateScroll: PropTypes.func,
    intl: PropTypes.object.isRequired,
    multiColumn: PropTypes.bool,
    isLoading: PropTypes.bool,
  }

  componentDidMount() {
    this.props.dispatch(fetchTrends());
    this.refreshInterval = setInterval(() => this.props.dispatch(fetchTrends()), 900 * 1000);
  }

  componentWillUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  handleHeaderClick = () => {
    this.column.scrollTop();
  }

  setRef = c => {
    this.column = c;
  }

  handleLoadMore = () => {

  }

  render() {
    const { intl, shouldUpdateScroll, columnId, multiColumn, trends, ...other } = this.props;
    const pinned = !!columnId;
    const emptyMessage = <FormattedMessage id='empty_column.trending_now' defaultMessage='There is nothing here!' />;

    const content = trends.map(hashtag =>
      <Hashtag key={hashtag.get('name')} hashtag={hashtag} />,
    );

    return (
      <Column bindToDocument={!multiColumn} ref={this.setRef} label={intl.formatMessage(messages.title)}>
        <ColumnHeader
          icon='hashtag'
          title={intl.formatMessage(messages.title)}
          onClick={this.handleHeaderClick}
          pinned={pinned}
          multiColumn={multiColumn}
        />


        <ScrollableList
          {...other}
          scrollKey={`trending_now_timeline-${columnId}`}
          onLoadMore={this.handleLoadMore}
          isLoading={trends.size === 0}
          showLoading={trends && trends.size === 0}
          shouldUpdateScroll={shouldUpdateScroll}
          emptyMessage={emptyMessage}
          bindToDocument={!multiColumn}
        >
          {content}
        </ScrollableList>
      </Column>
    );
  }

}
